// What a template previews against. A template has no survey of its own, so
// the preview needs content — and fixed content beats a real survey here:
// it always exercises every element a template can style, including ones a
// given survey happens not to use.

import type { DraftStep } from "@/features/preview/draft";

export const SAMPLE_SURVEY_NAME = "Sample survey";
export const SAMPLE_THANK_YOU = "Thanks for your feedback!";

export const SAMPLE_STEPS: DraftStep[] = [
    {
        kind: "choice",
        isMetric: true,
        config: {
            prompt: "How was your visit?",
            // The widest preset the product offers, copied option for
            // option from SCALE_PRESETS' "stars-5": the widest scale is the
            // one that would wrap first, so it is the one worth previewing.
            preset: "stars-5",
            options: [
                { key: "star-1", icon: "star", label: "1", value: 1 },
                { key: "star-2", icon: "star", label: "2", value: 2 },
                { key: "star-3", icon: "star", label: "3", value: 3 },
                { key: "star-4", icon: "star", label: "4", value: 4 },
                { key: "star-5", icon: "star", label: "5", value: 5 },
            ],
        },
    },
    {
        kind: "multi",
        isMetric: false,
        config: {
            mode: "flat",
            prompt: "What stood out?",
            options: [
                { key: "food", label: "The food" },
                { key: "staff", label: "The staff" },
                { key: "speed", label: "How quick it was" },
            ],
        },
    },
    {
        kind: "text",
        isMetric: false,
        config: { prompt: "Anything else?", placeholder: "Anything goes" },
    },
];
